<template>
    <div>
        <b-row>
            <b-col cols="auto" class="mr-auto">
              <b-form-group>
              
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="github" class="mr-1 btn-brand" @click="importParticipant()"><i class="fa fa-plus"></i><span>Importar Participantes do Evento</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>

        <b-row>
       
        <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
        </b-col>

        <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
            <p></p>
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
        </b-col>

        <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="table.perPage" id="perPage"
                :plain="true"
                :options="[5,10,20,50]">
                </b-form-select>
            </b-form-group>
        </b-col>
        
        </b-row>
        
  
        <b-table
            :items="filteredItems"
            :fields="table.fields"
            :select-mode="table.selectMode"
            responsive="sm"
            ref="selectableTable"
            selectable
            :primary-key="table.primaryKey"
            :tbody-transition-props="table.transProps"
            sort-icon-left
            :per-page="table.perPage"
            :current-page="table.currentPage"
            :busy="table.isBusy"
            hover
            striped
            style="min-height: 450px;"
            >

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
        

            <template v-slot:cell(participant)="data">
                {{ data.item.participant.name  }}
                <br><span class="text-muted small">{{ data.item.notes }}</span>
            </template>

            <template v-slot:cell(action)="data">
                <b-dropdown right :text="data.item.presence.name " :variant="presenceColor(data.item)" style="width: 150px">
                  <b-dropdown-item v-for="option in presenceDDL" :key="option.value" @click="changePresence(data.item, option)">{{ option.text }}</b-dropdown-item>                 
                </b-dropdown>
            </template>

            <template v-slot:cell(st)="data">
                <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
            </template>
        
            
        </b-table>
        <nav>
            <b-pagination :total-rows="totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Anterior" next-text="Próximo" />
        </nav>
  
        <b-modal title="Falta Justificada" class="modal-justified" v-model="justifiedModel" @ok="saveChangePresence" cancel-title="Cancelar" >
          
            <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Justificativa"
                    label-for="presenceNotes"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-textarea
                      id="presenceNotes"
                      v-model="presenceNotes"
                      placeholder=""
                      rows="3"
                    ></b-form-textarea>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

        </b-modal>
     

    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";
import { Switch as cSwitch } from '@coreui/vue'
  
/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}
  
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'eventParticipanntDateGridComponent',
    props: {
       item: {},
       eventDateId: 0
    },
    components: {
      cSwitch
    },
    data: () => {
        return {   
           justifiedModel: false,
           presenceItem: {},
           presenceNotes: '',
           presenceDDL: [
            {
                value: 1,
                text: 'Presença'
            },
            {
                value: 2,
                text: 'Falta'
            },
            {
                value: 3,
                text: 'Falta Justificada'
            }
           ],
           items: [],
           filters: {
            statusId: 0,
            key: '',
            status: 0
           },      
           switchLabelIcon: {
                dataOn: '\u2713',
                dataOff: '\u2715'
            },
           table: {
            fields: [
                //{key: 'show_details', label: "", thStyle: { width: "40px" } },
                //{key: 'id' },
                //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
                {key: 'participant', label: 'Participante', sortable: true  },
                //{key: 'serviceDescription', label: 'Descrição do Serviço', sortable: true },
                //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
                //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
                //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
                //{key: 'description', label: 'Descrição', sortable: false },
                //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
                //{key: 'presence.name', label: 'Presença', sortable: true, class: 'text-center', thStyle: { width: "200px" } },
                {key: 'action', label: 'Ação', sortable: false, class: 'text-right', thStyle: { width: "200px" } }
            ],
            sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
            currentPage: 1,
            perPage: 50,
            isBusy: false,
            modes: ['multi', 'single', 'range'],
            selectMode: 'multi',
            primaryKey: "id",
            transProps: {
               name: 'flip-list'
            }
           }
        }
    },
    computed: {
        
        selectedItem() {
            return this.item
        },
        totalRows: function () { return this.getRowCount() },
        filteredItems() {
            try {
                return this.items.filter(item => {
                return (this.filters.key == '' || (
                    this.$utils.filterString(item.name, this.filters.key)
                    //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    ))
                    && (this.filters.statusId==0 || item.statusId == this.filters.statusId )                  
                })
            }
            catch(e) {
                return this.items;
            }
        }
       
    },
    methods: {
        presenceColor(item) {
            if(item.presenceId==9)
                return 'secondary'            
            if(item.presenceId==2 || item.presenceId==3)
                return 'danger'
            return 'primary'
        },
        async saveChangePresence() {
            var s = this
            this.presenceItem.notes = this.presenceNotes
            
            await axios.post(
                this.$store.state.ws_url + "/event/participant/date/presence",
                this.presenceItem
            ).then(function (resp) {
                s.refreshData()
            }).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Evento',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 3000
                })
            })

        },
        changePresence(item, option) {
            var currentUser = this.$store.state.currentUser
            this.presenceItem = {
                id: item.id,
                presenceId: option.value,
                notes: this.presenceNotes,
                uid: currentUser.id,
                sid: currentUser.sid
            }

            if(option.value == 3) {
                this.presenceNotes = ''
                this.justifiedModel = true
            }
            else {
                this.saveChangePresence()
            }

        },
        async importParticipant() {

            var s = this
            var currentUser = this.$store.state.currentUser

            await axios.get(
                this.$store.state.ws_url + "/event/participant/date/import?eventDateId=" + s.selectedItem.id  + "&eventId=" + s.selectedItem.event.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.refreshData()
            }).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Evento',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 3000
                })
            });
            

        },
        getRowCount: function () {
            if(this.items)
                return this.items.length
            else
                return 0;
        },

        async refreshData() {
       
            var s = this;
            var currentUser = this.$store.state.currentUser;
            this.isBusy = true;

            var url = ''
            url = this.$store.state.ws_url + "/event/participant/date?eventDateId=" + s.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            //url = this.$store.state.ws_url + "/event/participant/date?groupId=" + s.cGroupId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            await axios.get(
                url
            ).then(function (resp) {
                s.items = resp.data.obj;

            }).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Evento',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })
            });
            
            this.isBusy = false;
        
        }
    },
    mounted: function() {
        this.refreshData()
    }
}
</script>